export const modalBGColor = { backgroundColor: "#FAFAFA" };
export const modalInputBorderColor = "#e2e8f0";